import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Send, Github } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative z-30 bg-black border-t border-gold/20 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold via-silver to-gold p-0.5">
                <div className="w-full h-full rounded-full bg-black flex items-center justify-center">
                  <span className="text-2xl font-bold text-gold">$F</span>
                </div>
              </div>
              <span className="text-2xl font-black text-gold tracking-tight">
                FLUMBERICO
              </span>
            </div>
            <p className="text-white text-sm max-w-md mb-6 leading-relaxed">
              The ultimate SEO social experiment. Compete to rank #1 for "flumberico" and earn $FLUMBERICO tokens. Ranking is Banking!
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com/flumberico" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="Twitter">
                <Twitter size={20} className="text-gold" />
              </a>
              <a href="https://t.me/flumberico" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="Telegram">
                <Send size={20} className="text-gold" />
              </a>
              <a href="https://github.com/flumberico" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center hover:bg-gold/20 transition-colors" aria-label="GitHub">
                <Github size={20} className="text-gold" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/whitepaper" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Whitepaper
                </Link>
              </li>
              <li>
                <Link to="/how-to-earn" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  How to Earn
                </Link>
              </li>
              <li>
                <Link to="/chart" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Live Chart
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Contact
                </Link>
              </li>
              <li>
                <a href="https://pump.fun/coin/Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Buy on Pump.fun
                </a>
              </li>
            </ul>
          </div>

          {/* Blog Articles Part 1 */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">SEO Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog/seo-equity-tokenization" className="text-white hover:text-gold transition-colors text-sm">
                  SEO Equity Tokenization
                </Link>
              </li>
              <li>
                <Link to="/blog/domain-authority-explained" className="text-white hover:text-gold transition-colors text-sm">
                  Domain Authority Guide
                </Link>
              </li>
              <li>
                <Link to="/blog/link-building-strategies-2025" className="text-white hover:text-gold transition-colors text-sm">
                  Link Building 2025
                </Link>
              </li>
              <li>
                <Link to="/blog/what-is-link-juice" className="text-white hover:text-gold transition-colors text-sm">
                  What is Link Juice?
                </Link>
              </li>
              <li>
                <Link to="/blog/high-authority-backlinks" className="text-white hover:text-gold transition-colors text-sm">
                  High Authority Backlinks
                </Link>
              </li>
              <li>
                <Link to="/blog/domain-rating-guide" className="text-white hover:text-gold transition-colors text-sm">
                  Domain Rating Guide
                </Link>
              </li>
              <li>
                <Link to="/blog/white-hat-link-building" className="text-white hover:text-gold transition-colors text-sm">
                  White Hat Link Building
                </Link>
              </li>
              <li>
                <Link to="/blog/check-domain-authority" className="text-white hover:text-gold transition-colors text-sm">
                  Check Domain Authority
                </Link>
              </li>
            </ul>
          </div>

          {/* Blog Articles Part 2 */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">SEO Strategies</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog/link-juice-distribution" className="text-white hover:text-gold transition-colors text-sm">
                  Link Juice Distribution
                </Link>
              </li>
              <li>
                <Link to="/blog/guest-posting-backlinks" className="text-white hover:text-gold transition-colors text-sm">
                  Guest Posting Guide
                </Link>
              </li>
              <li>
                <Link to="/blog/da-vs-dr-difference" className="text-white hover:text-gold transition-colors text-sm">
                  DA vs DR Difference
                </Link>
              </li>
              <li>
                <Link to="/blog/future-of-seo" className="text-white hover:text-gold transition-colors text-sm">
                  Future of SEO
                </Link>
              </li>
              <li>
                <Link to="/blog/ranking-success-case-study" className="text-white hover:text-gold transition-colors text-sm">
                  Ranking Success Stories
                </Link>
              </li>
              <li>
                <Link to="/blog/technical-seo-checklist-meme-coins" className="text-white hover:text-gold transition-colors text-sm">
                  Technical SEO Checklist
                </Link>
              </li>
              <li>
                <Link to="/blog/social-signals-seo-power" className="text-white hover:text-gold transition-colors text-sm">
                  Social Signals & SEO
                </Link>
              </li>
              <li>
                <Link to="/blog/viral-seo-campaign-lessons" className="text-white hover:text-gold transition-colors text-sm">
                  Viral SEO Campaigns
                </Link>
              </li>
              <li>
                <Link to="/blog/blockchain-seo-evolution" className="text-white hover:text-gold transition-colors text-sm">
                  Blockchain SEO Evolution
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-gold font-bold text-lg mb-4">Legal & Info</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/risk-warning" className="text-white hover:text-gold transition-colors text-sm font-medium">
                  Risk Warning
                </Link>
              </li>
              <li className="pt-2 border-t border-gold/20">
                <Link to="/sitemap" className="text-gold hover:text-white transition-colors text-sm font-bold">
                  📍 Site Map (All Pages)
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gold/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white text-base font-medium">
              © 2025 FLUMBERICO. All rights reserved.
            </p>
            <p className="text-white text-base font-medium">
              Contract: Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};